import Currency from '../currency';
import Entity from '../entity';
import Aircraft from './aircraft';
import AirlineCompany from './airlineCompany';
import Airport from './airport';
import FlightPriceGeneral from './flightPriceGeneral';
import FlightProvider from './flightProvider';
import FlightQuota from './flightQuota';

export default class FlightChangeUpdate extends Entity<string> {
  flightNo: string;
  code: string;
  destinationKey: string;
  $$hashKey: string;
  totalQuota: number;
  fromAirport: Airport;
  toAirport: Airport;
  airlineCompany: AirlineCompany;
  packageProvider: FlightProvider;
  airplane: Aircraft;
  departureDate: string;
  departureHour: string;
  arrivalDate: string;
  arrivalHour: string;
  currency: Currency;
  isActive: boolean;
  IsCampaign: boolean;
  baggageLimit: number;
  handBaggageLimit: number;
  isPropertyAnyChange: boolean;
  flightPriceGenerals: FlightPriceGeneral[];
  flightPriceRules: any[];
  flightQuotas: FlightQuota[];
  open: boolean;
  
}
